export default "__VITE_ASSET__CsdvyOUU__"